import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = { class: "prod-filter__list" };
import { useFilterStore } from "../store";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import RangeItem from "./RangeItem.vue";
import OptionsList from "./OptionsList.vue";
import { FilterItemTypes } from "../types";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FiltersList',
    emits: ["update"],
    setup: function (__props) {
        var store = useFilterStore();
        var items = storeToRefs(store).items;
        var filtered = computed(function () { return items.value.filter(function (i) { return i.type !== FilterItemTypes.Flag; }); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, function (item, key) {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        (item.type === 'list' || item.type === 'filterable')
                            ? (_openBlock(), _createBlock(OptionsList, {
                                key: 0,
                                item: item,
                                onUpdate: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('update', $event)); })
                            }, null, 8 /* PROPS */, ["item"]))
                            : _createCommentVNode("v-if", true),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (item.type === 'range')
                            ? (_openBlock(), _createBlock(RangeItem, {
                                key: 1,
                                item: item,
                                onUpdate: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('update', $event)); })
                            }, null, 8 /* PROPS */, ["item"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
